// extracted by mini-css-extract-plugin
export default {"ModeratorInvitationListItem":"bcg_a bhg_a bhg_r bhg_j","ModeratorInvitationListItem__left":"bcg_b bhg_a bhg_j","ModeratorInvitationListItem__note":"bcg_c bhg_fm"};